export default __webpack_public_path__ + "static/media/brand-trackmatic-logo.40dac8a2.png";